import React, { useEffect } from 'react'
import '../portfolio/portfolio.css'
import { FaArrowRightLong } from "react-icons/fa6";
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles



const portfoliodata = [
  {
    id: 0,
    title: "McDonald's app",
    image: require('../../images/portfolioimage1.webp'),
    link: "https://arttteo.com/portfolio/McDonalds",
  },
  {
    id: 1,
    title: "Alliance Group app",
    image: require('../../images/portfolioimage2.webp'),
    link: "https://arttteo.com/portfolio/Alliance+Group",
  },
  {
    id: 2,
    title: "Snicsnac AR app",
    image: require('../../images/portfolioimage3.webp'),
    link: "https://arttteo.com/portfolio/Snicsnac+AR",
  },
  {
    id: 3,
    title: "Volories app",
    image: require('../../images/portfolioimage4.webp'),
    link: "https://arttteo.com/portfolio/Volories",
  },
]



function Portfolio() {

  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  return (
    <section className='portfolio-main'>
      <div className="portfolio-title">
        <div className="A-title" data-aos='fade' >
          <span>Portfolio</span>
          <h1>Our Portfolio</h1>
          <p className='title-text'>We possess extensive expertise in collaborating with clients on high-caliber projects, ensuring exceptional outcomes and satisfaction.</p>
        </div>
        <a className='estimationbuttonlink' href="https://arttteo.com/portfolios">
          <button className="estimation-button" data-aos='fade'>
            <p>See Our Portfolio</p>
            <div className="arrow-circle">
              <FaArrowRightLong />
            </div>
          </button>
        </a>
      </div>
      <div className="portfolio-inner">
        {
          portfoliodata.map((project) => (
            <div className='p-l-project' data-aos='fade-up' key={project.id} >
              <img src={project.image} alt="" />
              <div className="p-l-absolute">
                <span className='case-study'>Case Study</span>
                <div className="p-l-bottom">
                  <h1>{project.title}</h1>
                  <a className='speciallycardlink' href={project.link}>
                  <button className="estimation-button">
                    <p>See More</p>
                    <div className="arrow-circle">
                      <FaArrowRightLong />
                    </div>
                  </button>
                  </a>
                </div>
              </div>
            </div>
          ))}
      </div>

    </section>
  )
}

export default Portfolio